import { useEffect, useState } from "react";
import { authHeader } from "../../_helpers/auth-header";
import { sharedAPIs } from "../api-endpoints/SharedServiceEndpoints";

export function useConfigTableColumns(moduleId, tableName) {
  const [loading, setLoading] = useState(true);
  const [configTableColumns, setConfigTableColumns] = useState({});

  useEffect(() => {
    getConfigTableColumns(moduleId, tableName)
      .then((res) => {
        setConfigTableColumns(res);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  }, [moduleId, tableName]);

  return {
    configTableColumns: {
      data: configTableColumns,
      loading: loading,
      set: setConfigTableColumns,
      get: getConfigTableColumns,
      save: saveConfigTableColumns,
    },
  };
}

export async function getConfigTableColumns(moduleId, tableName) {
  const url =
    sharedAPIs().getConfigTableColumns +
    "?moduleId=" +
    moduleId +
    "&tableName=" +
    tableName;

  const config = {
    method: "GET",
    headers: authHeader({ authJson: true, authForm: false, guestJson: false }),
  };

  let response = await fetch(url, config);

  if (response.ok) {
    response = await response.json();
  } else {
    response = {};
  }
  return response;
}

export async function saveConfigTableColumns(moduleId, tableName, columns) {
  const url = sharedAPIs().setConfigTableColumns;
  const payload = JSON.stringify({
    moduleId: moduleId,
    tableName: tableName,
    columns: columns,
  });
  const config = {
    method: "POST",
    body: payload,
    headers: authHeader({
      authJson: true,
      authForm: false,
      guestJson: false,
    }),
  };

  let response = await fetch(url, config);
  return response.ok; // Returns true or false
}
